var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 22.5H23.4508",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45117 12V1.5H21.5512V12",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0012 22.5H2.45117V8.17L8.62117 1.5",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5H21.55V8.17L15.34 1.5",
    stroke: "#55489E",
    strokeWidth: 1.9091,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.37V18.37",
    stroke: "#55489E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.37L12 18.37L9 15.37",
    stroke: "#55489E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.37L12 6.37L15 9.37",
    stroke: "#55489E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearHeight);
export default __webpack_public_path__ + "static/media/clear-height.169c69a5.svg";
export { ForwardRef as ReactComponent };